






import Vue from "vue";
import { mapState } from "vuex";
import { DELETE_ERROR } from "@/constants/mutation-types";

export default Vue.extend({
  name: "Error",
  props: ["name", "valueField"],
  data() {
    return {
      error: "",
    };
  },
  mounted() {
    document.addEventListener("click", (evt) => {
      const targetElement = evt.target as HTMLFormElement;

      if (targetElement.localName === "input" || targetElement.localName === "div") {
        if (targetElement.name === this.name) {
          this.deleteError();
        }
      }
    });

    this.error = this.$store.state.errors.get(this.name); // for errors from previous step
  },
  methods: {
    deleteError() {
      this.$store.commit(DELETE_ERROR, this.name);
    },
  },
  computed: {
    ...mapState(["isErrorsChanged"]),
  },
  watch: {
    isErrorsChanged() {
      this.error = this.$store.state.errors.get(this.name);
    },

    // tslint:disable-next-line: object-literal-key-quotes
    error() {
      if (this.name.indexOf("PolandTaxOfficeId") > -1 && this.valueField.length) {
        this.error = "";
      }
    },
  },
});
